import { DocumentService } from '@dealstack/frontend/shared/dataExchange/services/document/document.service';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useMutation } from '@tanstack/react-query';

export const useDownloadFileUsingFileStorageUrl = () => {
	const tCapManage = useTranslationCapManage();
	const getFileUrlMutation = useMutation({
		mutationFn: DocumentService.getDownloadPreSignedUrl,
	});

	const downloadFile = async ({
		fileId,
		dealId,
		fileName,
	}: {
		fileId: string;
		dealId: string;
		fileName: string;
	}) => {
		getFileUrlMutation.mutate(
			{
				dealId,
				fileId,
				fileName,
			},
			{
				onSuccess: async (data) => {
					window.location.href = data.payload?.downloadUrl ?? '';
				},
				onError: () => {
					showToastV2({
						title: tCapManage('documents.errors.download-document'),
						state: 'error',
					});
				},
			}
		);
	};

	return {
		downloadFile,
	};
};
